// extracted by mini-css-extract-plugin
export default {"container":"GT6YBU","content":"wfMcuo","title":"AWdEhX","text":"xMbb_Z","link":"u0KmMG","button":"Gg2ocy","mobile":"aZenwp"};